import moment from 'moment';
import 'moment/locale/zh-cn';
export  function activeMessageStateFilter(state){
   switch (state) {
     case 1:
       return "创建";
     case 2:
       return "已推送";
     default:
       return "作废";
   }
}


export function simCarFlowFilter(value) {
   if(value==undefined || value==null){
     return "";
   }
   return value+"MB"
}


//2019-09-07 星期六
export function  time1Filter(date) {
   return moment(date).format("YYYY-MM-DD dddd");
}

//2019-09-07
export function  time2Filter(date) {
  if(date){
    return moment(date).format("YYYY-MM-DD");
  }
  return "";
}

export function  balanceFormatFilter(value) {
  if(value!=undefined && value !=null){
    return value.toFixed(2);
  }
  return "0.00"
}

export function chargeCabinetOnlineStateFilter(state){

  switch (state) {
    case 0:
      return "离线";
    case 1:
      return "在线"
  }
}

export function chargeCabinetStateFilter(state) {

   if((typeof state)=='string'){
     if(!state){
        return "";
     }
     state=Number.parseInt(state);
   }
  switch (state) {
    case 0:
      return "初始化";
    case 1:
      return "静置";
    case 2:
      return "换电中";
    case 3:
      return "还电中";
    case 4:
      return "取电中";
    case 5:
      return "异常";
  }
}
export function fenceTypeFilter(state) {
  switch (state) {
    case 0:
      return "驶入报警";
    case 1:
      return "驶出报警";
    case 2:
      return "驶入驶出报警";
    default:
      return "未知";
  }
}

export function fenceStatusFilter(state) {
  switch (state) {
    case 0:
      return "启用";
    case 1:
      return "禁用";
    default:
      return "未知";

  }
}


export function cabinetStateFilter (state) {
  state=state+"";
  switch (state) {
    case "1":
      return "电池正在充电";
    case "2":
      return "电池充满";
    case "5":
      return "异常";
    case "0": case null: case undefined:
      return "无电池";
    default:
      return "未知";

  }
}

export function cabinetDoorFilter (state) {
  state=state+"";
  // 不同地方需要的类型不一样，有字符串，也有数字类型，都转换为字符串类型，数字+""=""
  switch (state) {
    case "1":
      return "开门";
    case "0":
      return "关门";
    default:
      return "未知";

  }
}


export function  memberStatusFilter(status) {

  switch (status) {
    case 1:
      return "启用";
    case 2:
      return "禁用";
    default:
      return  status
  }
}



export function batteryOnlineState(state) {
  switch (state) {
    case 0:
      return "离线";
    case 1:
      return "在线";
    default:
      return state;
  }
}
export function batteryBusinessState(state) {
  switch (state) {
    case 1:
      return "仓库库存";
    case 2:
      return "站点库存";
    case 3:
      return "租赁中";
    case 4:
      return "维修中";
    case 5:
      return "报废";
    default:
      return state;
  }
}


export  function  operatorNameFilter(operatorName) {
   if(operatorName){
     let flag="";
     for (let i = 0; i < operatorName.length-1; i++) {
       flag=flag+"*";
     }
     return  operatorName.substring(0,1)+flag;
   }
   return  operatorName;
}


export function pushMsgTypeFilter(type) {
  switch (type) {
    case 3:
      return "还电";
    case 2:
      return "低电量";
    case 1:
      return "取电";
    case 4:
      return "订单异常";
    case 5:
      return "工单任务";
    case 6:
      return "新增会员";
    case 7:
      return "申请禁用会员";
    default:
      return type;
  }
}
export function pushMsgStateFilter(state) {
  switch (state) {
    case 1:
      return "成功";
    case 2:
      return "失败";
    default:
      return state;
  }
}

export function pushMsgPlatform(value) {
  switch (value) {
    case 1:
      return "公众号";
    case 2:
      return "短信";
    default:
      return value;
  }
}


export function protocolTypeFilter(type) {
  switch (type) {
    case 1:
      return "V 1.0";
    case 2:
      return "V 2.0";
    case 3:
      return "V 3.0";
    default:
      return type;
  }
}

export function taskStatus(state) {
  switch (state) {
    case 1:
      return  "待执行";
    case 2:
      return "已取消";
    case 3:
      return "已执行";
    case 4:
      return "完成";
    case 5:
      return "终止";
    default:
      return state;
  }
}
export function taskStatusResult(state) {
  switch (state) {
    case 1:
      return "待执行";
    case 2:
      return "成功";
    case 3:
      return "失败";
    case 4:
      return "未响应";
    case 5:
      return "终止";
    default:
      return state;
  }
}
export  function stateResult(state){
  switch (state) {
    case 1:
      return "待执行";
    case 2:
      return "成功";
    case 3:
      return "失败";
    case 4:
      return "未响应";
    default:
      return "其他";
  }
}

export function filterData(data){
  if(data){
    return data.split(' ')[0]
  }
  return data
}

// BMS升级状态
export function remoteUpdateFilter(state) {
  switch (state) {
    case '0':
      return "未开始";
    case '1':
      return "下发中";
    case '2':
      return "升级中";
    case '3':
      return "升级完成";
    case '4':
      return "升级失败";
    case '5':
      return "程序回滚成功信息";
    case '6':
      return "程序回滚失败信息";
    case '7':
      return "通讯失效信息";
    default:
      return state;
  }
 }



// WEBPACK FOOTER //
// ./src/filters/index.js